import React, {PureComponent} from "react";
import LazyImg from "react-lazyload-image";
import "./AssetThumbnail.scss";


class AssetThumbnail extends PureComponent {
    render() {
        const {lazyLoadingThumbnails, thumbnailUrl, alt, isPhoto} = this.props;
        return <div className={"tvp-thumbnail-container"}>

            { isPhoto && <div className={"photo-background"} >
                <div className={"photo-background-inner"} style={{backgroundImage: `url(${thumbnailUrl})`}}>

                </div>
            </div> }
            {(!lazyLoadingThumbnails || isPhoto) ? <div className={"lazy-wrap"} style={{background: "none"}}>
                    <img
                        src={thumbnailUrl ? thumbnailUrl : ""}
                        alt={alt} style={{height: "100%", opacity: 1}}/></div> :

                <LazyImg
                    src={thumbnailUrl ? thumbnailUrl : ""}
                    alt={alt}/>
            }
        </div>
    }
}

AssetThumbnail.defaultPrtops = {
    lazyLoadingThumbnails: true,
    thumbnailUrl: null,
    alt: "",
    isPhoto: false
};

export default AssetThumbnail;

